import {
  useGetUsuarioByCurrentUser,
  useUsuarioEmpresaActiva,
} from "api/Usuario.hook"
import notification from "common/utils/notification"
import useContactos from "features/Contactos/hooks/useContactos"
import mapContactoFromApi from "features/Contactos/mappers/mapContactoFromApi"
import { contactosSelector } from "features/Contactos/redux/selectors/contactoSelectors"
import { clearContactoState } from "features/Contactos/redux/slices/contactoSlice"
import { userSelector } from "features/User/redux/slices/userSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import i18next from "i18next"
import { useEffect } from "react"
import { newDocumentoSelector } from "../redux/selectors/newDocumentoSelectors"
import { newDocumentoSettingsSelector } from "../redux/selectors/newDocumentoSettingsSelectors"
import {
  clearNewDocumentoSettingsState,
  setShowLogo,
} from "../redux/slices/newDocumentoSettingsSlice"
import {
  clearLibrado,
  clearNewDocumentoState,
  newDocumentoSelectorDoc,
  setAmILibrado,
  setComesFromMdf,
  setLibrado,
  setLibrador,
  setSerieAndNumero,
  setTipoDocumento,
  updateLogo,
} from "../redux/slices/newDocumentoSlice"

const useNewDocumento = ({
  librador,
  comesFromMdf,
  isLibrado,
  initialEmpresa,
  onChangeLastAvailableNumero,
  tipoDocumento,
}: $TSMigrationFixMe = {}) => {
  const { empresaActiva } = useSelector(userSelector)
  const { currentContacto } = useSelector(contactosSelector)
  const {
    activeCompany: { logoAsBase64 },
  } = useUsuarioEmpresaActiva()

  const { usuario } = useGetUsuarioByCurrentUser()
  const hasValidDireccion = Boolean(usuario?.empresaActiva?.direccion?.calle)
  const { librado } = useSelector(newDocumentoSelector)
  const objetoDocumento = useSelector(newDocumentoSelectorDoc)
  const { showCompradorVendedorModal } = useSelector(
    newDocumentoSettingsSelector
  )
  const { isDocumentToContact } = useSelector(newDocumentoSelectorDoc)
  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  const { editContacto } = useContactos()
  const dispatch = useDispatch()

  useEffect(() => {
    return () => {
      dispatch(clearContactoState())
      dispatch(clearNewDocumentoState())
      dispatch(clearLibrado())
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      dispatch(clearNewDocumentoSettingsState())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => {
    if (currentContacto) {
      dispatch(setLibrado(mapContactoFromApi(currentContacto)))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentContacto])

  useEffect(() => {
    if (logoAsBase64) {
      // @ts-expect-error TS(2345): Argument of type '{ logo: any; }' is not assignable...
      dispatch(setShowLogo(true))
      // @ts-expect-error TS(2345): Argument of type '{ logo: any; }' is not assignable...
      dispatch(updateLogo({ logo: logoAsBase64 }))
    }
  }, [dispatch, logoAsBase64])

  useEffect(() => {
    dispatch(setTipoDocumento(tipoDocumento))
  }, [dispatch, tipoDocumento])

  useEffect(() => {
    if (currentContacto && isLibrado) {
      dispatch(setLibrador(mapContactoFromApi(currentContacto)))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentContacto])

  useEffect(() => {
    if (onChangeLastAvailableNumero) {
      const serie = localStorage.getItem("last_used_serie") || "F"
      onChangeLastAvailableNumero(serie).then(({ data }: $TSMigrationFixMe) =>
        // @ts-expect-error TS(2345): Argument of type '{ serie: any; numero: any; }'...
        dispatch(setSerieAndNumero({ serie, numero: data }))
      )
    }
  }, [dispatch, onChangeLastAvailableNumero])

  useEffect(() => {
    dispatch(setComesFromMdf(comesFromMdf))
  }, [comesFromMdf, dispatch])

  useEffect(() => {
    if (!librador || isDocumentToContact) return
    dispatch(
      setLibrador({
        ...librador,
      })
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, librador])

  useEffect(() => {
    if (!objetoDocumento.librado && objetoDocumento) {
      dispatch(setAmILibrado(isLibrado))
      dispatch(setLibrado(isLibrado ? empresaActiva : initialEmpresa))
      dispatch(setLibrador(!isLibrado ? empresaActiva : initialEmpresa))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isLibrado, empresaActiva, initialEmpresa])

  useEffect(() => {
    // @ts-expect-error TS(2695): Left side of comma operator is unused and has no s...
    if ((empresaActiva, librado, !isLibrado)) {
      dispatch(setAmILibrado(isLibrado))
      dispatch(setLibrado(isLibrado ? empresaActiva : librado))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const checkIfLibradoHasEmailSelected = () => {
    if (!librado.email) {
      notification.errorServidor({
        body: `${i18next.t("notification.clientNoEmail")}`,
      })
      // @ts-expect-error TS(2554): Expected 5 arguments, but got 1.
      editContacto(librado.id)
      return false
    }

    return true
  }

  return {
    hasValidDireccion,
    showCompradorVendedorModal,
    checkIfLibradoHasEmailSelected,
  }
}

export default useNewDocumento
